// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-module__container__dGE7z {
  height: 100vh;
  overflow: hidden;
}
.index-module__header__LY9uy {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 0 10%;
}
.index-module__logoText__fqgAg {
  font-size: 27px;
  font-weight: 600;
  color: #351a55;
}
.index-module__contentWrapper__DFgx0 {
  margin-top: 64px;
  margin-bottom: 0px;
  padding: 2rem 10% 0px 10%;
  overflow-y: auto;
  height: calc(100vh - 64px);
  background-color: #fff;
}
.index-module__footer__C99Yv {
  padding: 16px 24px;
}
.index-module__footerFlex__KDZxa {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}
.index-module__poweredBy__GdeHo {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.index-module__poweredBy__GdeHo img {
  height: 24px;
}
.index-module__footerText__LHXR0 {
  flex-grow: 1;
  text-align: center;
  min-width: 150px;
}
@media (max-width: 576px) {
  .index-module__footerFlex__KDZxa {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .index-module__poweredBy__GdeHo,
  .index-module__footerText__LHXR0,
  .index-module__gx-layout-footer-content___GtfG {
    width: 100%;
    justify-content: center;
  }
  .index-module__poweredBy__GdeHo {
    margin-bottom: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PrivacyPolicy/index.module.less"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,wCAAwC;EACxC,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;EACA;;;IAGE,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".container {\n  height: 100vh;\n  overflow: hidden;\n}\n.header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 64px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #fff;\n  z-index: 1000;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 0 10%;\n}\n.logoText {\n  font-size: 27px;\n  font-weight: 600;\n  color: #351a55;\n}\n.contentWrapper {\n  margin-top: 64px;\n  margin-bottom: 0px;\n  padding: 2rem 10% 0px 10%;\n  overflow-y: auto;\n  height: calc(100vh - 64px);\n  background-color: #fff;\n}\n.footer {\n  padding: 16px 24px;\n}\n.footerFlex {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n.poweredBy {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n.poweredBy img {\n  height: 24px;\n}\n.footerText {\n  flex-grow: 1;\n  text-align: center;\n  min-width: 150px;\n}\n@media (max-width: 576px) {\n  .footerFlex {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n  .poweredBy,\n  .footerText,\n  .gx-layout-footer-content {\n    width: 100%;\n    justify-content: center;\n  }\n  .poweredBy {\n    margin-bottom: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `index-module__container__dGE7z`,
	"header": `index-module__header__LY9uy`,
	"logoText": `index-module__logoText__fqgAg`,
	"contentWrapper": `index-module__contentWrapper__DFgx0`,
	"footer": `index-module__footer__C99Yv`,
	"footerFlex": `index-module__footerFlex__KDZxa`,
	"poweredBy": `index-module__poweredBy__GdeHo`,
	"footerText": `index-module__footerText__LHXR0`,
	"gx-layout-footer-content": `index-module__gx-layout-footer-content___GtfG`
};
export default ___CSS_LOADER_EXPORT___;
